import { FC, useEffect, useState } from 'react';
import type { ConnectionState } from 'ts-components/PiChat/reducer';
import {
  SkeletonBar,
  SkeletonLines,
  SkeletonRoot,
  SkeletonToolRow,
  SkeletonUserBubble,
} from './styles';

export type ChatPhase = 'loading' | 'ready' | 'unavailable';

export const selectChatPhase = (
  connectionState: ConnectionState
): ChatPhase => {
  if (connectionState === 'connecting' || connectionState === 'disconnected') {
    return 'loading';
  }
  return connectionState === 'ready' ? 'ready' : 'unavailable';
};

export const LOADING_REVEAL_DELAY_MS = 150;

export const useLoadingReveal = (active: boolean): boolean => {
  const [elapsed, setElapsed] = useState(false);
  if (!active && elapsed) setElapsed(false);
  useEffect(() => {
    if (!active) return undefined;
    const timer = setTimeout(() => setElapsed(true), LOADING_REVEAL_DELAY_MS);
    return () => clearTimeout(timer);
  }, [active]);
  return active && elapsed;
};

export interface PiChatSkeletonProps {
  revealed: boolean;
}

export const PiChatSkeleton: FC<PiChatSkeletonProps> = ({ revealed }) => (
  <SkeletonRoot aria-hidden $revealed={revealed} data-qa-id="pi-chat-loading">
    <SkeletonUserBubble $width="60%" $height={37} />
    <SkeletonLines>
      <SkeletonBar $width="92%" $height={12} />
      <SkeletonBar $width="78%" $height={12} />
      <SkeletonBar $width="54%" $height={12} />
    </SkeletonLines>
    <SkeletonToolRow>
      <SkeletonBar $width="45%" $height={10} />
    </SkeletonToolRow>
    <SkeletonToolRow>
      <SkeletonBar $width="30%" $height={10} />
    </SkeletonToolRow>
  </SkeletonRoot>
);
